interface Product {
  id: number;
  name: string;
  price: string;
  image: string;
}

export function ProductGrid({ products }: { products: Product[] }) {
  return (
    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:grid-cols-3">
      {products.map((product) => (
        <div
          key={product.id}
          className="overflow-hidden rounded-lg border bg-white shadow-sm transition-shadow hover:shadow-md"
        >
          <div className="bg-[#f5f0e5]">
            <img
              src={product.image}
              alt={product.name}
              className="h-full w-full object-contain"
            />
          </div>

          <div className="p-4">
            <h4 className="font-medium">{product.name}</h4>
            <p className="text-gray-700">{product.price}</p>
          </div>
        </div>
      ))}
    </div>
  );
}
